import { Button, Grid, Typography } from '@mui/material';

import { VisuallyHiddenInput } from '../VisuallyHiddenInput';
import theme from './theme.module.scss';

type SelectionProps = {
  handleChange: (arg: any) => void;
  deSelectable?: boolean;
  label: string;
  activeId: any;
  id: any;
  required?: boolean;
  disabled?: boolean;
};

const Selection: React.FC<SelectionProps> = ({
  handleChange,
  label,
  activeId,
  id,
  deSelectable = false,
  required = false,
  disabled = false,
}) => {
  const handleClick = () => {
    if (disabled) return;
    if (deSelectable) activeId === id ? handleChange(null) : handleChange(id);
    else handleChange(id);
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={theme.container}
        onClick={() => handleClick()}
        sx={{
          position: 'relative',
          backgroundColor: theme =>
            activeId === id
              ? disabled
                ? theme.palette.grey[500]
                : theme.palette.primary.main
              : theme.palette.background.paper,
          color: theme =>
            activeId === id ? theme.palette.common.white : theme.palette.common.black,
        }}
      >
        <Button hidden style={{ position: 'absolute' }}>
          <VisuallyHiddenInput type="checkbox" required={required && activeId === null} />
        </Button>
        <Typography variant="overline">{label}</Typography>
      </Grid>
    </>
  );
};

export default Selection;
